(() => {
  const SELECTORS = [
    '#checkout',
    '#CartDrawer-Checkout',
  ];

  let checkoutInProgress = false;

  async function startCleanCheckout(button) {
    if (checkoutInProgress) return;

    checkoutInProgress = true;

    const originalText = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Se pregătește comanda...';

    try {
      const root =
        window.Shopify?.routes?.root || '/';

      const response = await fetch(
        `${root}cart/update.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            discount: '',
          }),
        }
      );

      if (!response.ok) {
        throw new Error(
          `Cart update failed: ${response.status}`
        );
      }

      await response.json();

      window.location.assign(
        `${root}checkout`
      );
    } catch (error) {
      console.error(
        'ASF checkout preparation failed:',
        error
      );

      checkoutInProgress = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalText;

      alert(
        'Comanda nu a putut fi pregătită. Vă rugăm să încercați din nou.'
      );
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const button =
        event.target.closest(
          SELECTORS.join(',')
        );

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      startCleanCheckout(button);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (
        form?.id !== 'cart' &&
        form?.id !== 'CartDrawer-Form'
      ) {
        return;
      }

      const submitter = event.submitter;

      if (
        !submitter ||
        submitter.name !== 'checkout'
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      startCleanCheckout(submitter);
    },
    true
  );
})();
